<template>
  <div class="app">
    <generic-view
      :title="$t('enterprises')"
      icon="building"
      v-bind:searchable="true"
      v-bind:configurable="false"
      v-bind:show_plus="true"
      :header_buttons="header_buttons"
      v-on:add="create"
      :show_refresh="true"
      @refresh="getData"
      ref="enterprise_component"
    >
      <div class="ui two horizontal link cards">
        <div
          class="card"
          v-on:click="select(enterprise)"
          v-for="(enterprise, index) in enterprises"
          v-bind:key="enterprise.uuid"
          v-bind:class="{
            hidden: enterprise.status_code == 'D' && !show_inactives,
            red: enterprise.status_code == 'D',
            black: enterprise.status_code == 'I',
            blue: enterprise.status_code == 'A',
          }"
        >
          <div class="image">
            <img src="/images/icons/enterprise_3.png" />
          </div>
          <div class="content">
            <div class="header">{{ enterprise.name }}</div>
            <div class="meta">
              <a>{{ enterprise.codename }}</a>
            </div>
            <div class="description">
              {{ $t("created") }} {{ enterprise.create_date }}
            </div>
          </div>
          <div class="ui bottom attatached basic buttons">
            <div class="ui button" v-on:click.stop="update(enterprise)">
              <i class="edit orange icon"></i>
              {{ $t("edit") }}
            </div>
            <div
              class="ui button"
              v-on:click.stop="remove(enterprise, index)"
              v-bind:class="{ disabled: enterprise.status_code == 'D' }"
            >
              <i class="trash red icon"></i>
              {{ $t("remove") }}
            </div>
          </div>
        </div>
      </div>
    </generic-view>

    <template v-for="(mdl, index) in enterprise_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:succedded="succedded"
        v-on:destroy="destroy_modal"
        :enterprise="enterprise"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api, toast } from "@/utils";
import EnterpriseModal from "./enterprise_modal/EnterpriseModal";
import GenericView from "@/components/GenericContainer";

export default {
  name: "SettingsEnterprisesManagement",
  data() {
    return {
      filter: "",
      processing: false,
      enterprises: [],
      enterprise: {},
      enterprise_modals: [],
      show_inactives: false,
      header_buttons: [
        {
          icon: "eye slash",
          tooltip: this.$t("toggle deleted"),
          click: this.toggle_inactive,
        },
      ],
    };
  },
  components: {
    EnterpriseModal,
    "generic-view": GenericView,
  },
  watch: {
    show_inactives() {
      let color = this.show_inactives ? "grey" : "black";
      this.header_buttons[0].color = color;
    },
  },
  methods: {
    toggle_inactive() {
      this.show_inactives = !this.show_inactives;
    },
    create() {
      this.enterprise = {};
      this.enterprise_modals.push(EnterpriseModal);
    },
    update(enterprise) {
      this.enterprise = enterprise;
      this.enterprise_modals.push(EnterpriseModal);
    },
    succedded() {
      this.getData();
    },
    remove(enterprise, index) {
      let vm = this;
      this.$alertify.confirm(
        vm.$i18n.t("are you sure to delete enterprise?"),
        function() {
          vm.processing = true;
          local_api(vm, "post", "/settings/enterprise/do-delete", {
            i: enterprise.uuid,
          })
            .then(() => {
              vm.enterprises.splice(index, 1);
            })
            .catch((err) => {
              toast(vm.$el, "error", err);
            })
            .finally(() => {
              vm.processing = false;
            });
        },
        function() {},
      );
    },
    destroy_modal() {
      this.enterprise_modals = [];
    },
    select(enterprise) {
      console.log(enterprise);
    },
    getData() {
      let vm = this;
      local_api(this, "post", "/settings/enterprise/do-get-all", {})
        .then((response) => {
          this.enterprises = response;
        })
        .catch((err) => {
          toast(vm.$el, "error", err);
        })
        .finally(() => {
          vm.processing = false;
        });
    },
  },
  mounted() {
    this.$refs.enterprise_component.toggle();
    this.processing = true;
    this.getData();
  },
};
</script>

<style scoped>
.deleted-enterprise {
  background-color: rgb(255, 245, 245) !important;
}
.inactive-enterprise {
  background-color: rgb(243, 243, 243) !important;
}
/* .active-enterprise {
  background-color: rgb(244, 255, 247) !important;
} */
</style>
